import React, {ReactElement} from 'react';

type MssageProps = {
  buttonTitle?: string;
  userType?: string | null;
};
const EnrolmentMessage: React.FC<MssageProps> = ({
  buttonTitle,
  userType,
}: MssageProps): ReactElement => {
  return (
    <React.Fragment>
      {buttonTitle === 'Create profile' && (
        <div>
          <div className=" text-sm grid place-items-center">
            <span className="font-bold font-roboto text-black_zero text-big">
              Enroll
            </span>
          </div>
          <div className=" text-xs grid place-items-center mt-4 mx-auto">
            {userType === 'employee' ? (
              <div>
                <p className="font-roboto text-center text-small   text-black_zero text-opacity-50 tracking-very_very_tightest">
                  Looks like the customer is not enrolled into Landmark Rewards.
                  Please share some details to enroll
                </p>
              </div>
            ) : (
              <div>
                {userType === 'customer' ? (
                  <p className="font-roboto text-center text-small   text-black_zero text-opacity-50 tracking-very_very_tightest">
                    Looks like you are not enrolled into Landmark Rewards.
                    Please share some details to get started with Max Buddy.
                  </p>
                ) : (
                  ''
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default EnrolmentMessage;
